import { HeadsetMic } from "@groww-tech-pvt/icon-store/mi"
import { MdsIcLogout } from "@groww-tech-pvt/icon-store/mint-icons";
import { BUTTON_SIZES, Button, VARIANTS } from "@groww-tech-pvt/ui-toolkit"
import { useState } from "react";
import { logoutUser } from "src/utils/config/interceptorUtils/helpers";
import { ONBOARDING_IMAGES } from "core/assets";
import OnbImage from "src/components/Image";

export const Header915 = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className='w-full flex py-4 px-2 justify-between absolute top-0 stretch z-1'>
      <OnbImage src={ONBOARDING_IMAGES.NOF_LOGO} alt='915' width={40} height={40} />

      <div className='flex gap-2 justify-center items-center'>
        {/* Mobile - Icon only */}
          <HeadsetMic size={16} onClick={() => setIsPopupOpen(!isPopupOpen)} className='md:hidden' />
        {/* Desktop - With text */}
        <div className='hidden md:block'>
          <Button
            buttonText='Help'
            onClick={() => setIsPopupOpen(!isPopupOpen)}
            variant={VARIANTS.SECONDARY}
            size={BUTTON_SIZES.SMALL}
            trailingIcon={() => <HeadsetMic size={16} />}
            dataTestId='help'
          />
        </div>

        {isPopupOpen && (
          <>
            <div
              className='fixed inset-0 z-40 animate-in fade-in duration-200'
              style={{ backgroundColor: 'var(--backgroundOverlaySecondary)' }}
              onClick={() => setIsPopupOpen(false)}
            />
            <div
              className='fixed rounded-lg shadow-xl z-50 p-4 flex items-center justify-center border border-primary glassBg top-12 animate-in fade-in slide-in-from-top-2 duration-300'
              style={{ right: '98px' }}
            >
              <div className='text-center'>
                <p className='text-sm text-primary flex flex-col'>
                  <div>
                    Email:{' '}
                    <a href='mailto:support@915.trade'>support@915.trade</a>
                  </div>
                  <div>
                    Contact: <a href='tel:+919008915915'>+91 9008915915</a>
                  </div>
                </p>
              </div>
            </div>
          </>
        )}

        <MdsIcLogout onClick={logoutUser} className="md:hidden ml-2" />
        <div className='hidden md:block'>
          <Button
            buttonText='Logout'
            onClick={logoutUser}
            variant={VARIANTS.SECONDARY}
            size={BUTTON_SIZES.SMALL}
            trailingIcon={() => (
              <MdsIcLogout />
            )}
          />
        </div>


      </div>
    </div>
  )
}
